import { TriangleForwardFillIcon } from "@lifesg/react-icons/triangle-forward-fill";

export const DownIcon = (): JSX.Element => <TriangleForwardFillIcon type="caret-down-lg" />;
